import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { VisuallyHidden } from "@components/VisuallyHidden";
import { CheckIcon } from "@icons/index";
import styles from "./styles/list.module.css";
export function ListBox({
  description,
  descriptionText,
  sortValues = [],
  showPanel = false,
  setSortBy,
  sortBy,
}) {
  const { t } = useTranslation("reviews");
  const onChange = (value) => setSortBy(value);

  const containerStyles = `
      ${styles.container}
      ${showPanel ? styles.showContainer : ""}
    `;

  const List = () => {
    return (
      <ul className={styles.list}>
        {sortValues.map((value) => (
          <ListItem key={value} value={value} />
        ))}
      </ul>
    );
  };

  const ListItem = ({ value }) => {
    return (
      <li className={styles.listItem}>
        <button className={styles.button} onClick={() => onChange(value)}>
          {t(value)}
          {sortBy === value && <CheckIcon />}
        </button>
      </li>
    );
  };

  return (
    <>
      <VisuallyHidden id={description}>{descriptionText}</VisuallyHidden>
      <div aria-describedby={description} className={containerStyles}>
        <List />
      </div>
    </>
  );
}

ListBox.propTypes = {};
